module.exports = __webpack_public_path__ + "img/chinesecompany145.61aa4174.png";